import axios from 'axios';

const myApi = axios.create({
    baseURL: '/api-v2',
  });

export default {
  getEventos(lang) {
    return myApi
      .get(lang + '/eventos')
      .then(response => response.data);
  },
  getEvento(lang,idEvento) {
    return myApi
      .get(lang+'/eventos/'+idEvento)
      .then(response => response.data);
  },
  getCategorias(lang) {
    return myApi.get(lang + '/eventos-categorias').then(response => response.data);
  }
};